import { FormControl } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { FormLabel } from '../../components/FormLabel'
import { InputGroup } from '../../components/InputGroup'
import { useContext } from 'react'
import { insuranceParamsContext } from '../../layouts/Wizard'
import { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'

export const AdditionalPropertyInfoDirect = () => {
    const { insuranceParams } = useContext(insuranceParamsContext)

    const isContracted = !!insuranceParams?.generalParams.contractNumber
    const { register, formState: { errors }, getValues } = useFormContext<WizardPropertyAdditionalData>()

    const appartmentNrRequired = getValues('property.additionalDataDirect.appartmentNumberRequired')

    return (
        <>
            {appartmentNrRequired &&
                <FormControl isRequired isInvalid={!!errors.property?.additionalDataDirect?.appartmentNumber}>
                    <FormLabel>Číslo bytu</FormLabel>
                    <InputGroup
                        isDisabled={isContracted}
                        id="appartmentNumber"
                        htmlSize={8}
                        autoComplete="off"
                        errors={errors.property?.additionalDataDirect?.appartmentNumber}
                        {...register('property.additionalDataDirect.appartmentNumber')}
                    />
                </FormControl>
            }
        </>
    )
}
